import React from 'react';
import { Text } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import * as Yup from "yup";
import InputField from "src/components/common/Inputs/InputField";
import { CustomButton } from "src/components/common/Buttons/CustomButton";

const schema = Yup.object().shape({
  email: Yup.string().email("Must be a valid email").required("Email is required"),
  password: Yup.string().required("Password is required"),
});

interface ParentSignInFormProps {
  onSubmit: (values: any) => void;
  loading: boolean;
  error?: string;
}

export const AdminSignInForm: React.FC<ParentSignInFormProps> = ({ onSubmit, loading, error}) => {
  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    validate: yupResolver(schema),
    validateInputOnBlur: true,
    validateInputOnChange: true,
  });

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <InputField
        label="Email Address"
        type="email"
        name="email"
        placeholder="Enter your email address"
        error={form.errors.email}
        {...form.getInputProps('email')}
      />
      <InputField
        label="Password"
        type="password"
        name="password"
        placeholder="Enter your password"
        showPasswordToggle
        error={form.errors.password}
        {...form.getInputProps('password')}
      />
      <CustomButton type="submit" loading={loading} disabled={!form.isValid()}>Sign In</CustomButton>
      {error && <Text color="red" className="mt-2">{error}</Text>}
    </form>
  );
};